export default "__VITE_ASSET__d9cc0b58__"